import { CartFlowController } from "../../CartFlowController";
import { ProductFlow } from "../ProductFlow";
import { ICartItems } from "../../../../Interfaces/Cart";
import { init as initImage } from "../Helper/Image";

export class Success extends ProductFlow {
    constructor(cartItems: ICartItems) {
        super("cart-flow-add-success", CartFlowController.EVENTS.CONFIGURE_SHIPPING, cartItems);
    }

    /**
     * determine if section is allowed to render
     */
    isAllowed(): boolean {
        super.isAllowed();
        return this.contentTemplate.dataset.allowed.split(",").includes(this.cartItems.items[0]?.product_type);
    }

    protected initTabs(): this {
        return this;
    }

    /**
     * obtain content from template
     * @private
     */
    protected initContent(): this {
        super.initContent();
        initImage(this.content.querySelector<HTMLImageElement>("img"), this.cartItems.items[0].image);
        return this;
    }
}
